import { useQuery } from '@tanstack/react-query';
import { catalogKeys } from '../lib/query-keys';

export type CatalogSource = 'legacy' | 'v2';

/*
 * Which catalog view this session has seen the API answer with, or null before
 * the first answer. Never fetched: the catalog hooks write it, and gcTime keeps
 * it for the session (the cache is cleared on logout).
 */
export function useCatalogSource() {
  return useQuery<CatalogSource | null>({
    queryKey: catalogKeys.source(),
    queryFn: () => null,
    enabled: false,
    staleTime: Number.POSITIVE_INFINITY,
    gcTime: Number.POSITIVE_INFINITY,
  }).data;
}
